module.exports = __webpack_public_path__ + "static/media/testfile_lrAutoStraighten.dc5648b1.zip";